export const TRANSLATIONS_JP_HOME_QUEUE_AND_ACTIVITY = {
  "home.actionItems.eyebrow": "保留中のアクション",
  "home.actionItems.title": "推奨アクション",
  "home.actionItems.connection": "キューを最新に保つための提案です。",
  "home.actionItems.empty": "保留中のアクションはありません。",
  "home.actionItems.unknownDocument": "不明なドキュメント",
  "home.actionItems.due": "期限",
  "home.smartQueue.eyebrow": "優先対応リスト",
  "home.smartQueue.title": "確認が必要なドキュメント",
  "home.smartQueue.totalLabel": "件の対応待ち",
  "home.smartQueue.description": "リスク・担当・各文書の状態で優先度を決めています。",
  "home.smartQueue.connection": "直近の検出日付と分類結果を入力にしています。",
  "home.smartQueue.metricsTitle": "運用メトリクス (任意)",
  "home.smartQueue.previewTitle": "優先度が高いもの",
  "home.smartQueue.previewSubtitle": "上位5件",
  "home.smartQueue.previewAction": "表示",
  "home.smartQueue.previewFilterRole": "ロールで絞り込み",
  "home.smartQueue.previewViewAll": "すべて見る",
  "home.smartQueue.status.needsReview": "あなたの確認が必要",
  "home.smartQueue.status.processing": "AIが処理中",
  "home.smartQueue.status.ready": "公開可能",
  "home.smartQueue.statusHelper.needsReview": "公開前に人が承認する必要があります。",
  "home.smartQueue.statusHelper.processing": "AIが引き続き抽出と分類を実行中です。",
  "home.smartQueue.statusHelper.ready": "すぐに公開や問い合わせに進めます。",
  "home.smartQueue.cta": "優先リストを開く",
  "home.smartQueue.tooltip": "優先度順のすべての文書の詳細を開きます。",
  "home.smartQueue.clearFilter": "状態フィルターを解除",
  "home.smartQueue.panelEyebrow": "優先度の詳細",
  "home.smartQueue.panelTitle": "アシスタントがグループ化したドキュメント",
  "home.smartQueue.panelSubtitle": "自動化ステータスとトリガーロール別に整理されています。",
  "home.smartQueue.closePanel": "優先リストパネルを閉じる",
  "home.smartQueue.badgeRole": "ロールで起動",
  "home.smartQueue.badgeDate": "日付で起動",
  "home.smartQueue.filterActive": "ロールまたは状態でフィルター中。",
  "home.smartQueue.actions.snooze": "24時間延期",
  "home.smartQueue.actions.done": "完了にする",
  "home.smartQueue.actions.assign": "自分に割り当て",  "home.smartQueue.markAsDone": "完了としてマーク",
  "home.smartQueue.snooze": "延期",
  "home.smartQueue.recommendedAction": "推奨されるアクション",  "home.smartQueue.mutation.snoozeSuccess": "24時間延期しました。",
  "home.smartQueue.mutation.doneSuccess": "完了にしました。",
  "home.smartQueue.mutation.assignSuccess": "自分に割り当てました。",  "home.smartQueue.mutation.reclassifySuccess": "ドキュメントの再分類に成功しました。",
  "home.smartQueue.reclassifyTooltip": "AIで再分析",
  "home.smartQueue.reclassifyModal.title": "ドキュメントの再分類",
  "home.smartQueue.reclassifyModal.reasonLabel": "理由（必須）",
  "home.smartQueue.reclassifyModal.reasonPlaceholder": "例: 契約として誤って分類されたドキュメント",
  "home.smartQueue.reclassifyModal.correctedTypeLabel": "正しい分類タイプ（必須）",
  "home.smartQueue.reclassifyModal.correctedTypePlaceholder": "正しいタイプを選択...",
  "home.smartQueue.reclassifyModal.originalTypeHint": "現在のタイプ",
  "home.smartQueue.reclassifyModal.notesLabel": "追加メモ（オプション）",
  "home.smartQueue.reclassifyModal.notesPlaceholder": "再分類に関する追加情報...",
  "home.smartQueue.reclassifyModal.confirm": "再分類",
  "home.smartQueue.reclassifyModal.cancel": "キャンセル",
  "home.smartQueue.reviewDocument": "ドキュメントを確認",
  "home.smartQueue.openDocument": "ドキュメントを開く",
  "home.smartQueue.executeAction": "アクションを実行",
  "home.smartQueue.mutation.actionSuccess": "アクションが正常に実行されました。",  "home.smartQueue.panelEmpty": "対応待ちのドキュメントはありません。",
  "home.smartQueue.empty": "保留中の項目はありません。最新の状態です。",
  "home.nextAction.eyebrow": "推奨アクション",
  "home.nextAction.title": "次のアクション",
  "home.nextAction.connection": "本日検知された内容に基づきます。",
  "home.nextAction.reason.pending_review": "承認待ちのドキュメントがあります。",
  "home.nextAction.reason.new_documents": "新しいドキュメントが取り込み可能です。",
  "home.nextAction.reason.ready_to_query": "すぐにアシスタントへ質問できます。",
  "home.nextAction.reason.due_soon": "期限が近づいています。",
  "home.nextAction.reason.overdue": "期限切れのドキュメントがあります。",
  "home.nextAction.reason.high_priority": "高優先度のドキュメントがあります。",
  "home.nextAction.reason.compliance_required": "コンプライアンス対応が必要です。",
  "home.nextAction.tooltipLabel": "この提案の理由",
  "home.nextAction.tooltip.queue": "検出された日付と優先リストから生成されています。",
  "home.nextAction.ack": "確認",
  "home.nextAction.cta": "表示",
  "home.nextAction.openDocument": "ドキュメントを開く",
  "home.nextAction.ackSuccess": "アクションを確認しました。",
  "home.nextAction.empty": "問題なし。今すぐ対応が必要なものはありません。",
  "home.nextAction.action.review": "レビュー",
  "home.nextAction.action.upload": "アップロード",
  "home.nextAction.action.chat": "チャット",
  "home.nextAction.reason.needs_review": "承認待ちのドキュメントがあります。",
  "home.lastActivity.eyebrow": "関連アクティビティ",
  "home.lastActivity.title": "最近の意思決定の変化",
  "home.lastActivity.connection": "意思決定に影響する変化、またはその理由を説明する変化だけを表示します。",
  "home.lastActivity.previewTitle": "変化した内容",
  "home.lastActivity.previewSubtitle": "最新",
  "home.lastActivity.previewAction": "確認",
  "home.lastActivity.markAllRead": "すべて既読にする",
  "home.lastActivity.type.classification": "分類",
  "home.lastActivity.type.ingestion": "取り込み",
  "home.lastActivity.type.extraction": "抽出",
  "home.lastActivity.type.normalization": "正規化",
  "home.lastActivity.type.validation": "検証",
  "home.lastActivity.tooltip": "クリックすると優先度への影響が表示されます。",
  "home.lastActivity.documentsImpacted": "関連ドキュメント",
  "home.lastActivity.queueImpacted": "意思決定への影響",
  "home.lastActivity.navigateQueue": "影響したキューを開く",
  "home.lastActivity.historyLink": "履歴を見る",
  "home.lastActivity.historyEyebrow": "関連ログ",
  "home.lastActivity.historyTitle": "アクティビティ履歴",
  "home.lastActivity.closeHistory": "履歴を閉じる",
  "home.lastActivity.openPanel": "関連アクティビティを表示",
  "home.lastActivity.closePanel": "関連アクティビティを閉じる",
  "home.lastActivity.historyEmpty": "表示できるイベントはありません。",
  "home.lastActivity.empty": "最近のアクティビティはありません。",
  "home.lastActivity.supportSignal": "補助シグナル",
  "home.lastActivity.event.decisionUpdated": "意思決定が更新されました",
  "home.lastActivity.event.missingInformationDetected": "不足情報が検出されました",
  "home.lastActivity.event.priorityRecalculated": "優先度が再計算されました",
  "home.lastActivity.event.evidenceAdded": "根拠が追加されました",
  "home.lastActivity.event.stateChanged": "状態が変わりました",
  "home.lastActivity.event.actionExecuted": "アクションが実行されました",
  "home.lastActivity.event.supportSignal": "補助更新",
  "home.lastActivity.event.decisionUpdatedCopy": "意思決定に最近変更があり、短く確認する価値があります。",
  "home.lastActivity.event.missingInformationDetectedCopy": "次のアクションを妨げる可能性がある不足データが見つかりました。",
  "home.lastActivity.event.priorityRecalculatedCopy": "優先度が変わり、より早い確認が必要になる場合があります。",
  "home.lastActivity.event.evidenceAddedCopy": "新しい根拠が追加され、推奨内容が再評価されました。",
  "home.lastActivity.event.stateChangedCopy": "最近の検証のあとで意思決定の状態が変わりました。",
  "home.lastActivity.event.actionExecutedCopy": "アクションが記録され、意思決定は新しい状態を反映するはずです。",
  "home.lastActivity.event.supportSignalCopy": "補助シグナルが記録されましたが、表示中の意思決定は直接変わっていません。",
  "home.nextBestDecision.eyebrow": "主役の決定",
  "home.nextBestDecision.title": "次の最良の決定",
  "home.nextBestDecision.viewDecision": "詳細を見る",
  "home.nextBestDecision.owner": "担当者",
  "home.nextBestDecision.dueAt": "期限",
  "home.nextBestDecision.nextAction": "次のアクション",
  "home.nextBestDecision.priority": "優先度",
  "home.nextBestDecision.priorityUnspecified": "階層なし",
  "home.nextBestDecision.risk": "リスク",
  "home.nextBestDecision.notAvailable": "データなし",
  "home.nextBestDecision.confidence": "信頼度",
  "home.nextBestDecision.functionalStatus": "推奨アクション",
  "home.nextBestDecision.recommendationCopy": "Home IA はこのケースに最適な業務上の推奨を示します。担当割り当て、延期、完了、破棄、再評価などの運用操作は詳細パネルのアクションを使ってください。",
  "home.entityActions.toggle": "エンティティの操作",
  "home.entityActions.questionsTitle": "おすすめの質問",
  "home.entityActions.questionsError": "質問を読み込めませんでした。",
  "home.entityActions.questionsEmpty": "このエンティティのおすすめの質問はありません。",
  "home.entityActions.askAboutEntity": "このエンティティについて質問する",
  "home.entityActions.askPrefill": "教えてください:",
  "home.entityActions.generate": "ドキュメントを生成",
  "home.entityActions.sourcesTitle": "これらのソースが使用されます",
  "home.entityActions.sourcesError": "ソースを読み込めませんでした。",
  "home.entityActions.sourcesEmpty": "生成に使用できる表示可能なソースがありません。",
  "home.entityActions.sourcesConfirm": "これらのソースで生成",
  "home.entityActions.cancel": "キャンセル",
  "home.entityActions.version": "バージョン",
  "home.recentChanges.title": "最近の変更",
  "home.recentChanges.viewAll": "すべて表示",
  "home.recentChanges.empty": "ドキュメントに関連する最近の変更はありません。",
  "home.recentChanges.errorTitle": "変更を読み込めませんでした",
  "home.recentChanges.errorMessage": "数秒後にもう一度お試しください。",
  "home.nextBestDecision.urgency.critical": "緊急度：高",
  "home.nextBestDecision.urgency.high": "早めに対応",
  "home.nextBestDecision.urgency.medium": "注視して監視",
  "home.nextBestDecision.urgency.low": "緊急度：低",
  "home.nextBestDecision.allClear.title": "すべて対応済み",
  "home.nextBestDecision.allClear.subtitle": "今すぐ対応が必要な決定はありません。この機会に今後の予定を確認しましょう。",
  "home.nextBestDecision.allClear.navLabel": "クイックアクセス",
  "home.nextBestDecision.allClear.reviewExpirations": "期限を確認",
  "home.nextBestDecision.allClear.viewChanges": "最近の変更を見る",
  "home.nextBestDecision.allClear.viewAlerts": "アラートを見る",
};
